export enum PaymentType {
    STANDARD = 'Standard',
    AUTOMATIC = 'Automatic',
    BROADCAST = 'Broadcast',
    ONLINE = 'Online',
    FORM = 'Form',
}
